import { lighten } from '@material-ui/core';
import { css } from 'styled-components/macro';
import ClassName from './ClassName';
import styledConsts from './styledConsts';
import styledFuncs from './styledFuncs';

const NO_HEIGHT_MARGIN_CLASS = `.${ClassName.NO_HEIGHT_MARGIN}`;
const NO_AUTO_MARGIN_CLASS = `.${ClassName.NO_AUTO_MARGIN}`;
const FORM_LINE_HEIGHT = '1.4em';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const styledMixins = {
  softShadow: css`
    box-shadow: 0px 3px 20px ${styledConsts.shadowColor};
  `,
  softShadowSmall: css`
    box-shadow: 0px 0px 10px ${styledConsts.shadowColor};
  `,
  softShadowTiny: css`
    box-shadow: 0px 0px 6px -0.4px ${styledConsts.shadowColor};
  `,
  softShadowForButtons: css`
    &,
    &:hover,
    &:active,
    &.Mui-disabled {
      box-shadow: 0px 0px 6px -0.4px ${styledConsts.shadowColor};
    }
  `,
  buttonColor: (bgColor: string) => css`
    &,
    &:hover,
    &:active {
      background-color: ${bgColor};
    }
  `,
  roundCorners: css`
    border-radius: 10px;
  `,
  bodyFontLarger: css`
    font-size: ${styledFuncs.pxToRem(16)};
  `,
  flexCenter: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  fullsize: css`
    width: 100%;
    height: 100%;
  `,
  withNext: css`
    margin-bottom: 0;
  `,
  collapseFix: css`
    flex: 0 0 auto;
  `,
  noRadiusLeft: css`
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  `,
  noRadiusRight: css`
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  `,
  noRadiusTop: css`
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  `,
  noRadiusBottom: css`
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `,
  muiUnfadeDisabledButton: css`
    &.MuiButton-contained.Mui-disabled {
      color: rgba(0, 0, 0, 0.87);
      background-color: #e0e0e0;
    }
  `,
  absoluteCentered: css`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  `,
  stripeyWarnBackground: css`
    background-image: linear-gradient(
      135deg,
      ${p => lighten(styledConsts.cWarning(p), 0.6)} 25%,
      ${p => lighten(styledConsts.cWarning(p), 0.3)} 25%,
      ${p => lighten(styledConsts.cWarning(p), 0.3)} 50%,
      ${p => lighten(styledConsts.cWarning(p), 0.6)} 50%,
      ${p => lighten(styledConsts.cWarning(p), 0.6)} 75%,
      ${p => lighten(styledConsts.cWarning(p), 0.3)} 75%,
      ${p => lighten(styledConsts.cWarning(p), 0.3)} 100%
    );
    background-size: 56.57px 56.57px;
  `,
  lineClamp: (lines: number) => css`
    display: -webkit-box;
    -webkit-line-clamp: ${lines};
    -webkit-box-orient: vertical;
    overflow: hidden;
  `,
  addMarginOnChildrenWithExceptions: (margin: string) => css`
    // Applies the following to immediate children
    > * {
      // If no exceptions specified by className AND
      // is not a collapse-container:
      // -> full margin applied
      &:not(${NO_HEIGHT_MARGIN_CLASS}):not(${NO_AUTO_MARGIN_CLASS}):not(.MuiCollapse-container) {
        margin: ${margin};
      }
      // If height exception but no full exceptions, OR
      // is a collapse-container with no full exceptions:
      // -> only width margin applied
      &${NO_HEIGHT_MARGIN_CLASS}:not(${NO_AUTO_MARGIN_CLASS}),
      &.MuiCollapse-container:not(${NO_AUTO_MARGIN_CLASS}) {
        margin-left: ${margin};
        margin-right: ${margin};
      }
      // Otherwise: no margin applied
    }
  `,
  formItemHeight: (
    height: number = styledConsts.formItemHeight
  ) => css`
    box-sizing: border-box;
    padding-top: calc((${height}px - ${FORM_LINE_HEIGHT}) / 2);
    padding-bottom: calc((${height}px - ${FORM_LINE_HEIGHT}) / 2);
    min-height: ${height}px;
    line-height: ${FORM_LINE_HEIGHT};
    font-size: ${styledFuncs.pxToRem(16)};
  `,
  flexHeight: (targetHeight: number, shrinkFactor = 1) => css`
    margin: pad();
    flex: 0 ${shrinkFactor} ${targetHeight};
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  `,
};
/* eslint-enable @typescript-eslint/explicit-module-boundary-types */

export default styledMixins;
